// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_el-a";
export var fulfillmentFormRail = "_el-9";
export var headerTitleRow = "_el-c";
export var orderDetailsWrapper = "_el-7";
export var orderLinkTrigger = "_el-2";
export var paymentInformationGrid = "_el-h";
export var paymentSummaryColumn = "_el-i";
export var shipmentContainer = "_el-b";
export var shipmentDetailsMainPane = "_el-8";
export var shipmentNavigationCard = "_el-5";
export var shipmentNavigationRail = "_el-3";
export var shipmentNavigationRailHeader = "_el-4";
export var shipmentSummaryFact = "_el-e";
export var shipmentSummaryGrid = "_el-d";
export var shipmentSummaryMetadataRow = "_el-f";
export var shipmentSummaryTags = "_el-g";
export var shipmentWorkspace = "_el-0";
export var shipmentWorkspaceContent = "_el-6";
export var shipmentWorkspaceHeader = "_el-1";